export const PageDataState = {
    Searchs: {
        external_user_id: {
            type: 'text',
            id: 'external_user_id',
            label: 'ผู้ใช้งานภายนอก',
            value: '',
            placeholder: 'ผู้ใช้งานภายนอก',
        },
        skills_set_id: {
            type: 'text',
            id: 'skills_set_id',
            label: 'ทักษะ skills set',
            value: '',
            placeholder: 'ทักษะ skills set',
        },
        external_user_status: {
            type: 'select',
            id: 'external_user_status',
            label: 'สถานะ',
            value: '',
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        external_user_id: {
            type: 'text',
            id: 'external_user_id',
            label: 'ผู้ใช้งานภายนอก',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        skills_set_type_id: {
            type: 'text',
            id: 'skills_set_type_id',
            label: 'ทักษะ skills set',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        skills_set_id: {
            type: 'text',
            id: 'skills_set_id',
            label: 'ประเภททักษะ Skills Set ',
            value: '',
            validator: {
                type: 'text',
                required: false,
            },
            error: { status: null, msg: '' }
        },
        status: {
            type: 'select',
            id: 'status',
            label: 'สถานะ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        }
    },
    InputGroup: {}
}